var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraySettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.858,
    height: 17.857,
    viewBox: "0 0 17.858 17.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-md-settings",
    d: "M19.085 13.2a5.584 5.584 0 0 0 .046-.893c0-.313-.046-.58-.046-.893L21 9.938a.41.41 0 0 0 .091-.58l-1.824-3.081a.445.445 0 0 0-.548-.179l-2.283.893a6.646 6.646 0 0 0-1.552-.891l-.32-2.366a.489.489 0 0 0-.457-.357h-3.653a.489.489 0 0 0-.454.355L9.632 6.1a7.732 7.732 0 0 0-1.553.893L5.8 6.1a.428.428 0 0 0-.548.179l-1.83 3.079a.539.539 0 0 0 .091.58l1.964 1.473c0 .313-.046.58-.046.893s.046.58.046.893L3.56 14.67a.41.41 0 0 0-.091.58l1.826 3.081a.445.445 0 0 0 .548.179l2.283-.893a6.645 6.645 0 0 0 1.552.893l.365 2.366a.443.443 0 0 0 .457.357h3.653a.489.489 0 0 0 .457-.357l.366-2.366a7.728 7.728 0 0 0 1.552-.893l2.283.893a.428.428 0 0 0 .548-.179l1.826-3.081a.538.538 0 0 0-.091-.58zm-6.8 2.232a3.126 3.126 0 1 1 3.2-3.125 3.142 3.142 0 0 1-3.204 3.122z",
    transform: "translate(-3.375 -3.375)",
    style: {
      fill: "#afafaf"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraySettings);
export default __webpack_public_path__ + "static/media/gray-settings.e1be9d75.svg";
export { ForwardRef as ReactComponent };